// extracted by mini-css-extract-plugin
module.exports = {"container":"_2LabI","navbar":"_2ng7g","logo":"a7BB5","toggle":"_3w-t5","open":"_2yTx6","body":"_2vyuT","menu":"_1nVmP"};